import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { Alert, Button, Card, CardBody, CardHeader, CardTitle, Col, Row } from 'reactstrap'
import { Form } from 'react-bootstrap'
import { message } from 'antd'
import moment from 'moment'

import ReferralOrderForm from './partials/ReferralOrderForm'
import ReferralsLimitCheckPoint from './partials/ReferralsLimitCheckPoint'

import { storeReferral } from '../Referrals/services'
import { storeReferralOrder } from './services'
import { handleError } from '../../helpers'

export default function NewReferralOrder() {
	const { user } = useSelector(state => state.auth)
	const { register, handleSubmit, formState: { errors }, setValue, watch } = useForm()
	const [loading, setLoading] = useState(false)
	const [canSend, setCanSend] = useState(false)
	const history = useHistory()

	const onSubmit = values => {
		setLoading(true)
		values.expire_at = moment().add(1,'month').format('YYYY-MM-DD HH:mm:ss')
		storeReferral({ 
			employee_id: user.id,
			name: values.referral_name, 
			document: values.referral_document, 
			email: values.referral_email,
			mobile: values.referral_mobile,
		})
			.then(res => {
				storeReferralOrder({
					...values, 
					referral_id: res.data.data.id,
					channel: 'stores',
				})
					.then(res => {
						message.success(res.data.message)
						message.info(res.data.vtex_message)
						history.push('/referral_orders')
					})
					.catch(error => {
						handleError(error)
						setLoading(false)
					})
			})
			.catch(handleError)
			.finally(() => setLoading(false))
	}

	const shareLink = () => {
		navigator.clipboard.writeText(`https://ventaempleados.spring.com.co/#/referido/${user.id}`)
		message.success('Link copiado al portapapeles')
	}

	return <Alert className='p-2' color='warning'>No es posible enviar incentivos a referidos en este momento.</Alert>

	return (
		<React.Fragment>
			<Row>
				<Col sm="12" md="8" lg="6">
					<ReferralsLimitCheckPoint 
						employeeId={user.id}
						canSend={canSend}
						setCanSend={setCanSend}
					/>
					<Card>
						<CardHeader>
							<CardTitle>Enviar incentivo a referido</CardTitle>
						</CardHeader>
						<CardBody>
							<Form onSubmit={handleSubmit(onSubmit)}>
								<Alert className='p-2' color='info'>Ingresa los datos de la persona que será tu referido.</Alert>
								<ReferralOrderForm 
									register={register}
									errors={errors}
									setValue={setValue}
									watch={watch}
									disabled={!canSend}
								/>
								<Button color="primary" type="submit" disabled={loading || !canSend}>
									Enviar Incentivo a Referido
								</Button>
							</Form>
						</CardBody>
					</Card>
				</Col>
				<Col sm="12" md="8" lg="6">
					<Card>
						<CardHeader>
							<CardTitle>Compartir Link de Referido</CardTitle>
						</CardHeader>
						<CardBody>
							<p>Comparte el link de referido con tu amigo o familiar para que pueda registrarse y recibir el descuento por ser tu referido.</p>
							<div 
								className='text-center mb-3 p-2 bg-light border text-link'
								onClick={shareLink}
							>
								https://ventaempleados.spring.com.co/#/referido/{user.id}
							</div>
							<Button 
								color="primary"
								onClick={shareLink}
							>
								Copiar Link
							</Button>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	)
}